<script lang="ts">
  import { onMount, onDestroy } from 'svelte'
  import { online } from '../stores'
  import { ping } from '../api'
  import { slog } from '../logging'

  let timeout

  async function goOnline() {
    slog('go_online')

    // After going online we want to wait a bit to avoid starting to ping too soon.
    // On the windows tablets the LTE connection is not really immediately
    // online after connecting and emitting the `online` event. This leads to
    // the first ping being a miss, and results in the reps having to wait longer
    // every time they open their tablet.
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(poll, 1500)
  }
  async function poll() {
    if (timeout) clearTimeout(timeout)

    if (!navigator.onLine) {
      $online = false
    } else {
      $online = await ping()
    }

    timeout = setTimeout(poll, window.PING_TIMEOUT || import.meta.env.VITE_PING_TIMEOUT || 10000)
  }

  async function goOffline() {
    slog('go_offline')

    if (timeout) clearTimeout(timeout)

    $online = false
  }

  onMount(async () => {
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)

    poll()
  })

  onDestroy(() => {
    window.removeEventListener('online', goOnline)
    window.removeEventListener('offline', goOffline)

    if (timeout) clearTimeout(timeout)
  })

  let onlineBefore = $online
  $: {
    if (onlineBefore !== $online) {
      let connection = {}
      if (navigator.connection) {
        // see https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation#instance_properties
        for (const property of ['type', 'effectiveType', 'rtt', 'downlink', 'downlinkMax', 'saveData']) {
          connection[property] = navigator.connection[property]
        }
      }
      slog($online ? 'app_online' : 'app_offline', connection)
      onlineBefore = $online
    }
  }
</script>
